import { registerGa4PulseMirror } from './ga4PulseBridge';
import { initGa4 } from './ga4Tracker';

let teardownPulseMirror: (() => void) | null = null;

/**
 * Initialize the dedicated frontend GA4 property (G-HNBX9YSHWR via env).
 * Does not modify legacy G-V03TEP7J74, GTM, or Pulse send pipeline.
 */
export const initGa4Analytics = (): void => {
  if (teardownPulseMirror) {
    teardownPulseMirror();
    teardownPulseMirror = null;
  }

  initGa4();
  teardownPulseMirror = registerGa4PulseMirror();
};

/** For tests — reset bootstrap hooks. */
export const __resetGa4BootstrapForTests = (): void => {
  if (teardownPulseMirror) {
    teardownPulseMirror();
    teardownPulseMirror = null;
  }
};
